import { CALCULATOR } from "../actionTypes";
//BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 - Start

const initialState = {
    arrExpiryDates : [],
    arrStrikePrice : []
};
const calculatorReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case CALCULATOR.GET_EXPIRY_DATES: {
            return {
                ...state,
                arrExpiryDates: actions.payload
            };
        }
        case CALCULATOR.GET_STRIKE_PRICE: {
            return {
                ...state,
                arrStrikePrice: actions.payload
            };
        }
        default : return state;
        
    }
}
export default calculatorReducer;

//BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 -End
